<template>
  <div class="collapse show collapse-horizontal aside col-lg-2" id="collapseWidthExample">
    <div class="aside-inner">
      <div class="aside-inner-title">영업기회 등록</div>
      <div class="accordion" id="accordionExample">
        <template v-for="depth1 in state.SnbDepth1" :key="depth1.key" >
          <template v-if="depth1.access">

            <div class="accordion-item">
              <h2 class="accordion-header">
                <ElButton type="accordionSide" :target="depth1.key">
                  {{ depth1.name }}
                </ElButton>
              </h2>
              <div :id="depth1.key" :class="isShowDiv()">
                <div class="accordion-body">
                  <ul class="accordion-submenu">
                    <template v-for="item in state.snbDepth2" :key="item.key">
                      <li v-if="item.access && depth1.key == item.key">
                        <router-link 
                          :class="checkActive(item)"
                          :to="item.link"
                        >
                          {{ item.name }}
                        </router-link>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </div>

            
          </template>
          
        </template>


      </div>
    </div>      
  </div>
 
</template>

<script setup>
import {computed} from 'vue'
import { useRoute } from "vue-router";
import { useUserStore } from '@/store/user';
import { router } from '@/router';
const route = useRoute()
const userStore = useUserStore()

const menuIdList = ['MSR_SO_001','MSR_SO_002','MSR_SO_003','MSR_SO_004']

const state = computed(()=>{
  const data = {
    SnbDepth1 :[
        {key : 'sr1',name:'영업기회 등록관리', link : 'M001',id:'M001',access:false},
        // {key : 'sr2',name:'영업기회 조회/수정', link : ''},
    ],
    snbDepth2 : [
        {key : 'sr1',name:'영업기회 등록/수정', link : '/sr/MSR_SO_001',id:'M001M001',access:false ,activeLink : ['/sr/MSR_SO_001','/sr/MSR_SO_003']},
        {key : 'sr1',name:'영업기회 조회', link : '/sr/MSR_SO_002',id:'M001M002',access:false},
    ],
    keyStatus : ''
  }

  const menuList = Object.keys(data).filter(name => name.includes('Depth'))

  menuList.forEach((depth)=>{
    data[depth].forEach((item)=>{
      if (userStore.user) {
        item.access = item.id ? userStore.user.mnUrl.includes(item.id) : true
      }
    })
  })

  Object.values(data).forEach(datum => {
    Object.values(datum).forEach(item => {
      if (item.link.toLowerCase() === route.path.toLowerCase()) {
        if(userStore.user && !item.access){
          alert('접근 불가한 페이지입니다.')
          router.push('/')
          return
        }
        data.keyStatus = item.key

      }
    })
  })

  return data
})
//[state.keyStatus === depth1.key ? 'accordion-collapse collapse show' : 'accordion-collapse collapse']
function isShowDiv(){
  return menuIdList.includes(location.pathname.split('/')[location.pathname.split('/').length -1])
}

function checkActive(item){
  let activeFlag = false
  if(item.activeLink){
    activeFlag = item.activeLink.includes(location.pathname)
  }else{
    activeFlag = item.link === location.pathname
  }

  return activeFlag ? 'route-active' : ''
}
</script>